import "./StatusOverlay.scss";

function Message({ message }) {
    if (!message) return null;
    return (
        <div className="message">
            {message}
        </div>
    )
}

function AnimatedCheckmark({ size = 80, strokeColor = "#4BB543" }) {
    const px = typeof size === "number" ? `${size}px` : size;
    return (
        <div className="animated-checkmark" style={{ width: px, height: px, display: "inline-block" }}>
            <svg viewBox="0 0 52 52" width="100%" height="100%" aria-hidden="true" focusable="false">
                <circle
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    style={{
                        strokeDasharray: 166,
                        strokeDashoffset: 166,
                        transformOrigin: "50% 50%",
                        animation: "ac-circle 0.6s ease-out forwards"
                    }}
                />
                <path
                    d="M14 27 l7 7 16-16"
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                        strokeDasharray: 48,
                        strokeDashoffset: 48,
                        animation: "ac-check 0.35s 0.55s ease-out forwards"
                    }}
                />
            </svg>
            <style>{`
                        @keyframes ac-circle { to { stroke-dashoffset: 0; } }
                        @keyframes ac-check  { to { stroke-dashoffset: 0; } }
                    `}</style>
        </div>
    );
}

function Icon({ status }) {
    if (status === "success") {
        return (
            <div className="icon">
                <AnimatedCheckmark />
            </div>
        )
    }
    return null;
}

const DEFAULT_TIMEOUT = 1500;

/**
 * Render a status overlay with an optional message.
 * @param {object} config - Whether to show the overlay. If not null, the contents are used to configure the display.
 * @returns {JSX.Element | null}
 */
export function StatusOverlay({ config }) {

    if (!config) return null;

    if(config.status === "success") {
        setTimeout(config.close, config.timeout || DEFAULT_TIMEOUT)
        return (
            <div className="status-overlay">
                <Icon status="success" />
                <Message message={config.message || config.status} />
            </div>
        )
    }
}
